import constants from '../../../../../globals/constants';
const validEmailRegexPattern = constants.patterns.validEmail();
export const validation = {
    validateOn: ['blur'],
    validationRegex: validEmailRegexPattern,
    required: true,
    message: {
        default: 'Please enter a valid email address'
    }
}